import { CommonKVDelTreeMessage } from "../../types";
import { MessageComponent, MessageComponentProps } from "./Message";
import { HighlightedText } from "../../agent/stateComponents/SimpleComponentVisualization";

const KVDelTreeMessage: MessageComponent<CommonKVDelTreeMessage> = ({
  message,
  textFilter,
}: MessageComponentProps<CommonKVDelTreeMessage>) => {
  return (
    <>
      <h6>
        <code>
          <HighlightedText text={message.key ?? ""} textFilter={textFilter} />
        </code>
      </h6>
    </>
  );
};

export default KVDelTreeMessage;
